import React, { Fragment, useState, useEffect, useContext, useCallback, useRef } from "react";
import { useLocation } from "react-router-dom";
import CustomizerContext from "../../_helper/Customizer";
import { MENUITEMS } from "./Menu";
import SidebarIcon from "./SidebarIcon";
import SidebarLogo from "./SidebarLogo";
import SidebarMenu from "./SidebarMenu";
import SidebarProfile from "./SidebarProfile";

const MOBILE_BREAKPOINT = 1200; // Cuba'nın mobil sidebar break'i

const Sidebar = (props) => {
  const {
    toggleIcon,
    toggleSidebar,
  } = useContext(CustomizerContext);
  const location = useLocation();
  const id = location.pathname.split("/").pop();

  // Mobil: route değişiminde sidebar otomatik kapanır (toggleIcon=true ise
  // zaten kapalı). Tek source of truth = toggleIcon, overlay buradan derive.
  useEffect(() => {
    if (
      typeof window !== "undefined" &&
      window.innerWidth <= MOBILE_BREAKPOINT &&
      !toggleIcon
    ) {
      toggleSidebar(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.pathname]);

  const [mainmenu, setMainMenu] = useState(MENUITEMS);
  // Mobil overlay: sidebar açık (toggleIcon=false) + viewport mobil ise göster.
  const [isMobile, setIsMobile] = useState(false);
  const overlayActive = !toggleIcon && isMobile;
  const sidebarRef = useRef(null);
  const overlayRef = useRef(null);

  const handleResize = useCallback(() => {
    setIsMobile(window.innerWidth <= MOBILE_BREAKPOINT);
  }, []);

  const setNavActive = useCallback((item) => {
    MENUITEMS.forEach((menuItems) => {
      menuItems.Items.forEach((Items) => {
        if (Items !== item) {
          Items.active = false;
        }
        if (Items.children && Items.children.includes(item)) {
          Items.active = true;
        }
        if (Items.children) {
          Items.children.forEach((submenuItems) => {
            if (submenuItems.children && submenuItems.children.includes(item)) {
              Items.active = true;
              submenuItems.active = true;
            }
          });
        }
      });
    });
    item.active = !item.active;
    setMainMenu({ mainmenu: MENUITEMS });
  }, []);

  useEffect(() => {
    window.addEventListener("resize", handleResize);
    handleResize();

    const currentUrl = window.location.pathname;
    MENUITEMS.forEach((items) => {
      items.Items.forEach((Items) => {
        if (Items.path === currentUrl) setNavActive(Items);
        if (Items.children) {
          Items.children.forEach((subItems) => {
            if (subItems.path === currentUrl) setNavActive(subItems);
            if (subItems.children) {
              subItems.children.forEach((subSubItems) => {
                if (subSubItems.path === currentUrl) setNavActive(subSubItems);
              });
            }
          });
        }
      });
    });

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, [id, handleResize, setNavActive]);

  // Mobil drawer açıkken body scroll'u kilitle — yoksa arkadaki sayfa kayıyor
  // ve menünün alt kısmına ulaşılamıyordu (sahip feedback'i #3). Kilit kalktığında
  // class temizlenir; unmount'ta da garanti temizlik.
  useEffect(() => {
    const cls = "sidebar-locked";
    if (overlayActive) {
      document.body.classList.add(cls);
    } else {
      document.body.classList.remove(cls);
    }
    return () => document.body.classList.remove(cls);
  }, [overlayActive]);

  // Overlay artık `!toggleIcon && isMobile`'dan derive ediliyor; manuel state YOK.
  // Geriye dönük uyumluluk için no-op stub bırakıyoruz (SidebarMenu prop bekliyor).
  const activeClass = () => {};

  // Overlay tıklanırsa sidebar'ı kapat (tek toggle, overlay kendi kendine gizlenir).
  const closeOverlay = () => {
    toggleSidebar(true);
  };

  return (
    <Fragment>
      <div
        ref={overlayRef}
        className={`bg-overlay1 ${overlayActive ? "active" : ""}`}
        onClick={closeOverlay}
      />
      <div
        ref={sidebarRef}
        className={`sidebar-wrapper ${toggleIcon ? "close_icon" : ""}`}
        sidebar-layout="stroke-svg"
      >
        <SidebarIcon />
        <SidebarLogo />
        <SidebarMenu
          setMainMenu={setMainMenu}
          props={props}
          setNavActive={setNavActive}
          activeClass={activeClass}
        />
        {/* Alt profil bloğu — header'dan taşındı (sahip feedback'i). Avatar +
            ad/rol; tıklayınca menü YUKARI açılır. Rail'de yalnız avatar. */}
        <div className="sidebar-footer">
          <SidebarProfile />
        </div>
      </div>
    </Fragment>
  );
};

export default Sidebar;
